module.exports = __webpack_public_path__ + "img/jr1.6bce05c1.png";